// src/utils/CorrecaoEnderecoUtils.js
export const criarCorrecaoEndereco = (inicial, atual, camposEditados) => Object.fromEntries(
  [...camposEditados].filter((campo) =>
    String(atual?.[campo] ?? '').trim() !== String(inicial?.[campo] ?? '').trim()
  ).map((campo) => [campo, String(atual?.[campo] ?? '').trim()])
);
